import { TReduxStore } from '../../../AppModulesWrapper';
import { loadBetPosition } from '../../thunks/betPosition/loadBetPosition';
import { checkService } from '../../thunks/checkout/checkService';
import { loadPublishTerms } from '../../thunks/publishTerms/loadPublishTerms';

export const updateStore = async (store: TReduxStore) => {
  await store.dispatch(loadPublishTerms());

  await Promise.all([store.dispatch(loadBetPosition(true)), store.dispatch(checkService(true))]);
};
